import { render } from "./Transports.vue?vue&type=template&id=3885b5e7&scoped=true"
import script from "./Transports.vue?vue&type=script&lang=js"
export * from "./Transports.vue?vue&type=script&lang=js"

import "./Transports.vue?vue&type=style&index=0&id=3885b5e7&lang=css&scoped=true"

import exportComponent from "/Users/jean-yvesfournet/Documents/projects/javascript/vue/shop-flash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3885b5e7"]])

export default __exports__